import { useState } from "react";

// ── Dashboard Mockup ──
function DashboardMockup() {
  return (
    <div
      style={{
        background: "#13111e",
        borderRadius: 12,
        overflow: "hidden",
        width: "100%",
      }}
    >
      {/* Navbar */}
      <div
        style={{
          background: "#1a1730",
          padding: "12px clamp(12px, 4vw, 20px)",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 10,
          borderBottom: "1px solid #2a2550",
        }}
      >
        <span style={{ color: "#ffffff", fontWeight: 700, fontSize: 15 }}>
          Elementus Labs
        </span>

        <div
          style={{
            flex: "1 1 200px",
            minWidth: 0,
            background: "#0d0c1a",
            borderRadius: 8,
            border: "1px solid #2a2550",
            display: "flex",
            alignItems: "center",
            padding: "8px 12px",
            gap: 8,
          }}
        >
          <svg width="13" height="13" viewBox="0 0 16 16" fill="none">
            <circle cx="7" cy="7" r="5" stroke="#6b7280" strokeWidth="1.5" />
            <path
              d="M11 11l3 3"
              stroke="#6b7280"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
          <span style={{ color: "#6b7280", fontSize: 13 }}>
            Enter an address or transaction…
          </span>
        </div>
      </div>

      {/* Body */}
      <div style={{ padding: "32px 24px 28px" }}>
        <h2
          style={{
            color: "#a78bfa",
            fontSize: 28,
            fontWeight: 800,
            margin: "0 0 6px",
            letterSpacing: "-0.01em",
          }}
        >
          Welcome back, Peter!
        </h2>
        <p
          style={{
            color: "#9ca3af",
            fontSize: 13,
            margin: "0 0 20px",
            fontWeight: 500,
          }}
        >
          Recently Created
        </p>

        {/* Cards */}
        <div
          style={{
            display: "flex",
            gap: 14,
            overflowX: "auto",
            paddingBottom: 6,
          }}
        >
          {/* Card 1 */}
          <div
            style={{
              background: "#1a1730",
              border: "1px solid #3d3860",
              borderRadius: 12,
              padding: "16px 16px 14px",
              flex: "0 0 clamp(260px, 80%, 340px)",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                marginBottom: 34,
              }}
            >
              <span
                style={{
                  background: "#252340",
                  color: "#a78bfa",
                  fontSize: 10,
                  fontWeight: 700,
                  padding: "4px 10px",
                  borderRadius: 20,
                  letterSpacing: "0.06em",
                }}
              >
                RADAR
              </span>
              <span style={{ color: "#f7931a", fontSize: 18, lineHeight: 1 }}>
                ₿
              </span>
            </div>
            <div style={{ marginBottom: 14 }}>
              <div
                style={{
                  color: "#ffffff",
                  fontSize: 13,
                  fontWeight: 700,
                  marginBottom: 4,
                }}
              >
                opqrst…987654
              </div>
              <div style={{ color: "#9ca3af", fontSize: 11 }}>
                Tracking for VASP Operation
              </div>
            </div>
            <div
              style={{
                borderTop: "1px solid #3d3860",
                paddingTop: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <div
                  style={{
                    width: 7,
                    height: 7,
                    borderRadius: "50%",
                    background: "#7c3aed",
                    flexShrink: 0,
                  }}
                />
                <span style={{ color: "#9ca3af", fontSize: 10 }}>
                  Updated yesterday at 13:12
                </span>
              </div>
              <span style={{ color: "#9ca3af", fontSize: 18, lineHeight: 1 }}>
                ⋮
              </span>
            </div>
          </div>

          {/* Card 2 */}
          <div
            style={{
              background: "#1a1730",
              border: "1px solid #3d3860",
              borderRadius: 12,
              padding: "16px 16px 14px",
              flex: "0 0 clamp(260px, 80%, 340px)",
            }}
          >
            <div style={{ marginBottom: 34 }}>
              <span
                style={{
                  background: "#252340",
                  color: "#a78bfa",
                  fontSize: 10,
                  fontWeight: 700,
                  padding: "4px 10px",
                  borderRadius: 20,
                  letterSpacing: "0.06em",
                }}
              >
                PULSE
              </span>
            </div>
            <div style={{ marginBottom: 14 }}>
              <div
                style={{
                  color: "#ffffff",
                  fontSize: 13,
                  fontWeight: 700,
                  marginBottom: 4,
                }}
              >
                bC1rst…9dwEn3
              </div>
              <div style={{ color: "#9ca3af", fontSize: 11 }}>Report 329</div>
            </div>
            <div
              style={{
                borderTop: "1px solid #3d3860",
                paddingTop: 10,
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: 7,
                  height: 7,
                  borderRadius: "50%",
                  background: "#7c3aed",
                  flexShrink: 0,
                  marginRight: 6,
                }}
              />
              <span style={{ color: "#9ca3af", fontSize: 10 }}>
                Created on 2022-10-…
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── DotGrid ──
function DotGrid() {
  const dots = [];
  const cols = 4,
    rows = 5;
  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      const highlighted = (r === 2 && c === 0) || (r === 4 && c === 1);
      dots.push(
        <circle
          key={`${r}-${c}`}
          cx={c * 52 + 26}
          cy={r * 52 + 26}
          r={highlighted ? 20 : 15}
          fill={highlighted ? "#a78bfa" : "#ddd6fe"}
          opacity={highlighted ? 1 : 0.45 + c * 0.13}
        />,
      );
    }
  }
  return (
    <svg
      viewBox="0 0 240 280"
      style={{ width: "100%", maxWidth: 180, height: "auto" }}
    >
      {dots}
    </svg>
  );
}

// ── StepRow ──
function StepRow({ s, isLast }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={`flex flex-col gap-4 lg:grid lg:grid-cols-[80px_1fr_1fr] lg:gap-x-10 items-start w-full py-8 lg:py-10 ${
        !isLast ? "border-b border-indigo-200" : ""
      }`}
    >
      {/* Number */}
      <div
        className={`font-bold text-base border-2 border-violet-700 rounded-lg px-3 py-1.5 w-fit transition-all duration-300 font-mono tracking-wide ${
          hovered
            ? "bg-violet-700 text-white"
            : "bg-transparent text-violet-700"
        }`}
      >
        {s.num}
      </div>

      {/* Title */}
      <h3 className="text-2xl lg:text-3xl font-normal text-gray-900 m-0 leading-snug ">
        {s.title}
      </h3>

      {/* Description */}
      <p className="text-sm lg:text-base text-gray-700 m-0 leading-relaxed">
        {s.desc}
      </p>
    </div>
  );
}

// ── Steps Data ──
const steps = [
  {
    num: "01",
    title: "Elevated API delivery",
    desc: "Whether through our comprehensive API or bulk egress, get empowered access for observation and modeling to tell the data story, mitigate risks, and identify critical investment opportunities for your organization.",
  },
  {
    num: "02",
    title: "Enhanced Block Explorer",
    desc: "Organize and enrich blockchain data to deliver precise attribution and beneficial ownership insights. Featuring robust clustering, root address identification, and custom tagging capabilities, organizations can accurately track the flow of funds and gain unparalleled visibility into complex networks.",
  },
  {
    num: "03",
    title: "Intuitive mapping",
    desc: "Powered by SourceFlow, our dynamic visualization tool transforms complex on-chain data into graphical representations for actionable insights to support risk modeling, market opportunities, and investigations.",
  },
];

// ── About Component ──
export default function About() {
  return (
    <div style={{ background: "#ffffff", color: "#0f0f1a" }}>
      {/* SECTION 1 */}
      <section className="grid lg:grid-cols-2 mt-20">
        {/* Left */}
        <div className="flex items-center justify-center lg:justify-end p-6 lg:pl-12 overflow-hidden">
          <div className="w-full md:w-[calc(100%+60px)] max-w-[640px]">
            <div className="w-full rounded-2xl flex items-center justify-center">
              <DashboardMockup />
            </div>
          </div>
        </div>

        {/* Right */}
        <div className="bg-white flex flex-col justify-center  py-10  lg:py-16 px-14">
          <h1 className="text-[1.9rem] sm:text-[2rem] md:text-[3rem] lg:text-[4rem] font-semibold text-[#0a0a14] leading-tight tracking-tight mb-3">
            How Elementus
          </h1>
          <div className="mb-8 md:mb-12">
            <span className="inline-block text-[1.8rem] sm:text-[2rem] md:text-[3rem] lg:text-[4rem] font-semibold text-purple-600 border-2 md:border-3 border-purple-300 rounded-full px-6 md:px-10 py-1 md:py-2 leading-tight tracking-tight">
              simplifies
            </span>
          </div>
          <p className="text-gray-600 text-sm md:text-base leading-relaxed max-w-md">
            By combining the most comprehensive data set available with our
            patented algorithms, Elementus enables organizations to discover
            valuable market intelligence, investigate on-chain activity,
            identify risk, and create new revenue opportunities.
          </p>
        </div>
      </section>

      {/* SECTION 2 */}
      <section className="bg-white py-10 lg:py-16 px-8 md:px-14">
        {steps.map((s, i) => (
          <StepRow key={i} s={s} isLast={i === steps.length - 1} />
        ))}
      </section>

      {/* SECTION 3 */}
      <section
        className="py-10  lg:py-16 px-14"
        style={{
          background: "#f8f7ff",
          boxSizing: "border-box",
        }}
      >
        <div style={{ marginBottom: "clamp(24px, 4vw, 48px)" }}>
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              background: "#ede9fe",
              color: "#4b5563",
              fontSize: "0.75rem",
              fontWeight: 600,
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              padding: "6px 14px",
              borderRadius: 6,
            }}
          >
            About Us
          </span>
        </div>
        <h2
          style={{
            fontSize: "clamp(2rem, 5vw, 4rem)",
            fontWeight: 700,
            color: "#0f0f1a",
            margin: "0 0 clamp(40px, 6vw, 72px)",
            letterSpacing: "-0.025em",
            lineHeight: 1.1,
            fontFamily: "'Georgia', serif",
          }}
        >
          Unlock the{" "}
          <span
            style={{
              color: "#7c3aed",
              border: "2.5px solid #a78bfa",
              borderRadius: "999px",
              padding: "2px 22px 6px",
              display: "inline-block",
            }}
          >
            full picture
          </span>{" "}
          of the blockchain
        </h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit, minmax(min(100%, 260px), 1fr))",
            gap: "clamp(32px, 5vw, 0px) 80px",
            alignItems: "center",
            maxWidth: 1200,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              paddingLeft: "clamp(0px, 2vw, 20px)",
            }}
          >
            <DotGrid />
          </div>
          <div>
            <p
              style={{
                color: "#374151",
                fontSize: "clamp(0.9rem, 1.5vw, 1.05rem)",
                lineHeight: 1.85,
                margin: "0 0 32px",
              }}
            >
              Element Us Labs was founded out of a genuine passion for solving
              blockchain's toughest challenges. We believe that the key to
              unlocking the true potential of digital assets lies in robust,
              reliable on-chain data—the foundation for any meaningful analysis.
              By harnessing our patented technology and deep expertise, we
              provide unparalleled transparency and insights that help
              businesses accurately assess risk and capitalize on opportunities
              in an evolving digital economy.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
